module.exports = __webpack_public_path__ + "static/media/rightsideimg.b9498c30.png";